import { forwardRef } from 'react';
import { IconButton as ChakraIconButton, IconButtonProps as ChakraIconButtonProps } from '@chakra-ui/react';
import { cn } from './lib/cn';

type IconButtonProps = ChakraIconButtonProps & {
    variant?: 'outline' | 'ghost';
    href?: string;
};

export const IconButton = forwardRef(function IconButton(
    { variant = 'outline', href, className, ...rest }: IconButtonProps,
    ref
) {
    if (variant === 'outline') {
        return (
            <ChakraIconButton
                ref={ref}
                href={href}
                variant='outline'
                border='1px solid'
                borderColor='gray.300'
                backgroundColor='white'
                className={cn('shadow-sm', className)}
                {...rest}
            />
        );
    }

    return <ChakraIconButton ref={ref} href={href} variant='ghost' {...rest} />;
});
